import * as AppRoutes from 'src/app-routes';

export function buildComponentUrlArray(routeGroups: AppRoutes.RouteMap[]): string[] {
  const urls: string[] = [];
  routeGroups.forEach(routeGroup => {
    Object.values(routeGroup).forEach(routeProps => urls.push(routeProps.path));
  });
  return urls;
}
